var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container"},[_c('div',{staticClass:"login-container"},[_c('h1',[_vm._v("BIBO")]),_c('button',{staticClass:"btn btn-primary btn-lg",attrs:{"type":"button"},on:{"click":_vm.signIn}},[_vm._v("Login")])])])}
var staticRenderFns = []

export { render, staticRenderFns }